import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Typography, Button } from '@mui/material';

const ChartHeader = ({ title, description, showRefreshButton, handleManualRefresh, isRefreshing }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant='h6' gutterBottom>
          {title}
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 0 }}>
          {description}
        </Typography>
      </Box>

      {showRefreshButton && (
        <Button
          variant='outlined'
          startIcon={<RefreshIcon sx={{ animation: isRefreshing ? 'spin 1s linear infinite' : 'none' }} />}
          onClick={handleManualRefresh}
          disabled={isRefreshing}
          sx={{
            textTransform: 'none',
            borderColor: '#e0e0e0',
            color: '#757575',
            ml: 2,
            flexShrink: 0,
            '&:hover': {
              borderColor: '#1976d2',
              color: '#1976d2',
              backgroundColor: 'transparent'
            },
            '&:disabled': {
              borderColor: '#e0e0e0',
              color: '#bdbdbd'
            }
          }}
        >
          {isRefreshing ? 'Refreshing...' : 'Refresh Data'}
        </Button>
      )}
    </Box>
  );
};

export default ChartHeader;
